'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SettingAction": "Polaris-SettingAction",
  "Setting": "Polaris-SettingAction__Setting",
  "Action": "Polaris-SettingAction__Action"
};

exports.default = styles;
